module.exports = __webpack_public_path__ + "img/dixon.6bdda0e0.png";